"use client";

import React, { useCallback } from "react";
import styled from "styled-components";
import { P, Span, Title } from "@motorata/base-ui.components.atoms.typography";
import { ProfilesType } from "@motorata/base-ui.types.api";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { Pagination } from "@motorata/base-ui.components.molecules.pagination";
import { useRouter } from "next/navigation";
import NotFoundProfilesBlock from "../../components/shared/NotFoundProfilesBlock";
import ProfileBlock from "../../components/shared/ProfileBlock";
import { CarShopFilterType } from "@/helpers/paramsCarShop.helper";

const CarShopListContainer = ({ data, filters }: {
  filters: CarShopFilterType
  data: ProfilesType
}) => {
  const router = useRouter()

  const handleChangeCurrentPage = useCallback(
    (page: number) => {
      router.push(`/komis-samochodowy/${filters.province || "all"}/${filters.city || "all"}/${page}`)
    },
    []
  )

  return (
    <Box>
      <Box marginBottom="M">
        <Title type="primary" elementType="label" margin="0">
          Lista komisów samochodowych
        </Title>
        <P color="third" margin="0">
          Znależliśmy dla Ciebie <Span fontWeight="bold"> {data?.totalElements} </Span>partnerów
        </P>
      </Box>
      <Content>
        {data?.totalElements === 0 &&
          <NotFoundProfilesBlock />
        }
        {data?.content?.map(profile => (
          <ProfileBlock key={profile.id} profile={profile} />
        ))}
        {!!data?.totalPages && (
          <Pagination
            defaultPage={data.pageable.pageNumber + 1}
            totalPages={data?.totalPages}
            onChange={(number) => handleChangeCurrentPage(number)}
          />
        )}
      </Content>
    </Box>
  );
};

export default CarShopListContainer;

const Content = styled.div`
  width: 100%;

  > div {
    margin-bottom: 10px;
  }
`;
